import { gql, useQuery } from '@apollo/client';
import { getUserNotificationPreferences } from './__generated__/getUserNotificationPreferences';

export const USER_NOTIFICATION_PREFERENCES = gql`
  query getUserNotificationPreferences {
    user {
      notificationPreferences {
        teamsNotificationPrefs {
          communityParticipation
          productUpdates
          upcomingEvents
          wellbeingReminders
        }
        emailNotificationPrefs {
          communityParticipation
          productUpdates
          upcomingEvents
          wellbeingReminders
        }
      }
    }
  }
`;

export const useUserNotificationPreferences = () => {
  const { data, loading, error, refetch } =
    useQuery<getUserNotificationPreferences>(USER_NOTIFICATION_PREFERENCES, {
      errorPolicy: 'all',
      returnPartialData: false,
    });

  return { data, loading, error, refetch };
};
